import React from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';

import './style.css'

export default function ReactDatePicker(props) {
  const {
    minDate,
    maxDate,
    minTime,
    maxTime,
    disabled,
    selected,
    onChange,
    className,
    dateFormat,
    timeFormat,
    timeCaption,
    timeIntervals,
    showTimeSelect,
    placeholderText,
    wrapperClassName,
    showTimeSelectOnly
  } = props;

  const checkMinDate = (date) => {
    if (minDate && moment(date).isAfter(minDate)) {
      return checkMinTime(date);
    }
    else {
      const time = new Date(date);
      if (moment(date, "hh:mm a").isBefore(moment(minDate, "hh:mm a"))) {
        return moment(minDate).set('hours', time.getHours()).set('minute', time.getMinutes()).toDate();
      }
      else return minDate;
    }
  }

  const checkMinTime = (date) => {
    const this_minTime = moment(minTime).format("HH:MM");
    const this_dateTime = moment(date).format("HH:MM");

    if (this_dateTime < this_minTime) {
      const time = new Date(minTime);
      return moment(date).set('hours', time.getHours()).set('minute', time.getMinutes()).toDate();
    }
    return date;
  }

  return <DatePicker
    minDate={minDate}
    maxDate={maxDate}
    minTime={minTime}
    maxTime={maxTime}
    disabled={disabled}
    selected={selected}
    className={className}
    dateFormat={dateFormat}
    timeFormat={timeFormat}
    timeCaption={timeCaption}
    timeIntervals={timeIntervals}
    showTimeSelect={showTimeSelect}
    placeholderText={placeholderText}
    wrapperClassName={wrapperClassName}
    showTimeSelectOnly={showTimeSelectOnly}
    onChange={date => onChange(checkMinDate(date))}
  />
}
